<div class="card">
  <div class="card-content">
    <div class="page-header">
      <h4 translationEditableDirective="CREATE_WARD">{{"CREATE_WARD" | translate}}</h4>
    </div>

    <form class="form" (submit)="onSubmit($event)">
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="ID">{{"ID" | translate}}</label>
        <div class="control">
          <input
            class="input"
            name="id"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['id'])"
            [ngClass]="{ 'is-danger': hasError('id') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('id')">
          {{ getError("id") }}
        </p>
      </div>
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="NAME">{{"NAME" | translate}}</label>
        <div class="control">
          <input
            class="input"
            name="name"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['name'])"
            [ngClass]="{ 'is-danger': hasError('name') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('name')">
          {{ getError("name") }}
        </p>
      </div>

      <div class="field is-grouped">
        <div class="control">
          <button [disabled]="isLoading" type="submit" class="button is-link" translationEditableDirective="SUBMIT">
            {{"SUBMIT" | translate}}
          </button>
        </div>
        <div class="control">
          <a
            [routerLink]="['/admin/wards']"
            class="button is-link is-light"
            translationEditableDirective="CANCEL"
           >{{"CANCEL" | translate}}</a
          >
        </div>
      </div>
    </form>
  </div>
</div>
